import { render, staticRenderFns } from "./ShowPersonOptions.vue?vue&type=template&id=a247ca5c&"
import script from "./ShowPersonOptions.vue?vue&type=script&lang=js&"
export * from "./ShowPersonOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports